import styled from "styled-components";
import { TextField } from "@material-ui/core";
import PhoneInput2 from "react-phone-input-2";
import { Autocomplete } from "@material-ui/lab";
import { Chip } from "@material-ui/core";

export const PhoneNumberInfo = styled.p``;
export const EmailInfo = styled.p``;
export const CreatedAtInfo = styled.p``;

export const Field = styled(TextField)`
  width: 100%;
  margin-bottom: 20px !important;

  :last-child {
    margin-bottom: 10px !important;
  }
`;

export const PhoneInput = styled(PhoneInput2)`
  margin-bottom: 20px !important;

  .react-tel-input {
    margin-bottom: 20px;
  }

  .react-tel-input .form-control {
    width: 100%;
  }
`;

export const TagsPicker = styled(Autocomplete)`
  margin-top: 20px;
  padding-top: 10px;
  background: rgba(61, 155, 233, 0.2);
  border-radius: 5px;
`;

export const TagInput = styled(TextField)`
  width: 320px;
  height: 100%;
  padding: 12px;
  background: transparent;
`;

export const Tag = styled(Chip)`
  border-radius: 7px;
  background-color: #d3d3d3;
  border: 0;

  svg {
    color: #3d3d3d;
  }
`;
